import { KnowledgeProps } from '@Pages/Knowledge/props';
import React from 'react';
import s from './style.module.css';
import { URL } from '@Pages/url';

type KnowledgePaggerProps = {
    prevKnowledge?: KnowledgeProps;
    nextKnowledge?: KnowledgeProps;
};

const KnowledgePagger = (props: KnowledgePaggerProps) => {
    const formatText = (text: string, prev: boolean) => {
        const prefix = prev ? '< ' : '';
        const suffix = prev ? '' : ' >';
        const trimmedText = text.length > 32 ? `${text.substring(0, 32)}...` : text;
        return `${prefix}${trimmedText}${suffix}`;
    };

    return (
        <div className={s.pagger_wrapper}>
            {props.prevKnowledge ? (
                <a className={s.pagger_item} href={`${URL.KNOWLEDGE}/${props.prevKnowledge.id}`}>
                    {formatText(props.prevKnowledge.title, true)}
                </a>
            ) : (
                <div />
            )}
            {props.nextKnowledge ? (
                <a className={s.pagger_item} href={`${URL.KNOWLEDGE}/${props.nextKnowledge.id}`}>
                    {formatText(props.nextKnowledge.title, false)}
                </a>
            ) : (
                <div />
            )}
        </div>
    );
};

export default KnowledgePagger;
